import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { modals } from 'helpers'

import Modal from 'components/Modal/Modal'
import EditableTable from 'components/EditableTable/EditableTable'

import s from './DialogWithFormTableModal.scss'


class DialogWithFormTableModal extends PureComponent {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
  }

  static defaultProps = {
    name: modals.DialogWithFormTable,
  }

  close = () => {
    const { name } = this.props

    actions.modals.close(name)
  }

  handleSubmit = (data) => {
    const { data: { onSubmit } } = this.props

    this.close()
    onSubmit(data)
  }

  render() {
    const { data: { title, text, onSubmit, ...rest } } = this.props

    return (
      <Modal onClose={this.close}>
        <div>
          <div className={s.title}>{title}</div>
          <div className={s.text}>{text}</div>
          <EditableTable
            {...rest}
            onSubmit={this.handleSubmit}
          />
        </div>
      </Modal>
    )
  }
}


export default DialogWithFormTableModal
